import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background":"blue"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: "流向",
      modelValue: _ctx.isShowDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowDialog) = $event)),
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("商品编号：" + _toDisplayString(_ctx.row.spbh), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("品名：" + _toDisplayString(_ctx.row.pm), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("规格：" + _toDisplayString(_ctx.row.gg), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("单位：" + _toDisplayString(_ctx.row.dw), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("包装：" + _toDisplayString(_ctx.row.bz), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createTextVNode("零售价：" + _toDisplayString(_ctx.row.pfj), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createTextVNode("生产厂家：" + _toDisplayString(_ctx.row.sccj), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.defaultdate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultdate) = $event)),
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  size: "small",
                  style: {"width":"95%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: $setup.search
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: $setup.exportExcel
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          id: "out-recordtable",
          data: _ctx.recordlist,
          border: "",
          style: {"width":"100%"},
          size: "small",
          height: "80%"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              formatter: $setup.formatDate,
              prop: "rq",
              label: "日期",
              width: "90px"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              prop: "dwbh",
              label: "单位编码",
              width: "90px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "dwm",
              label: "单位名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "gxbj",
              label: "购销标记",
              width: "70px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "sl",
              label: "数量",
              width: "60px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "dj",
              label: "单价",
              width: "60px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "hsje",
              label: "含税金额",
              width: "70px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "kl",
              label: "扣率",
              width: "50px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ph",
              label: "批号",
              width: "200px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "fph",
              label: "发票号",
              width: "100px"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}